/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Master_BadgeInputs */

const en_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const de_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const fr_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const es_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const it_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const nl_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const pl_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const fi_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const da_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const sv_story_bank_master_badge = /** @type {(inputs: Story_Bank_Master_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

/**
* | output |
* | --- |
* | "Master" |
*
* @param {Story_Bank_Master_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_master_badge = /** @type {((inputs?: Story_Bank_Master_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Master_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_master_badge(inputs)
	if (locale === "fr") return fr_story_bank_master_badge(inputs)
	if (locale === "es") return es_story_bank_master_badge(inputs)
	if (locale === "it") return it_story_bank_master_badge(inputs)
	if (locale === "nl") return nl_story_bank_master_badge(inputs)
	if (locale === "pl") return pl_story_bank_master_badge(inputs)
	if (locale === "fi") return fi_story_bank_master_badge(inputs)
	if (locale === "da") return da_story_bank_master_badge(inputs)
	if (locale === "sv") return sv_story_bank_master_badge(inputs)
	return en_story_bank_master_badge(inputs)
});